import { fetchChannelAssetRule } from '../../phoenix';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';

export function fetchChannelAssetRulesQuery(id: number) {
  return queryClient.fetchQuery({
    queryKey: queryKeys.assetRules(id),
    queryFn: () => fetchChannelAssetRule(id),
    staleTime: Infinity,
  });
}
